export function RiskBannerWrapper({
  children,
  id
}: {
  children: React.ReactNode;
  id?: string;
}) {
  return (
    <div className="pointer-events-auto flex flex-col bg-[#26ddf9]" id={id}>
      {children}
    </div>
  );
}

export function RiskBannerContentWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex justify-center border-b border-gray-100 bg-[#67686814] p-4">
      {children}
    </div>
  );
}
